import React from 'react';
type SparkleProps = {
  className?: string;
};
export function Sparkle({
  className = ''
}: SparkleProps) {
  return <svg viewBox="0 0 24 24" fill="currentColor" className={`pointer-events-none absolute text-gold-light ${className}`} aria-hidden="true" data-id="element-360" data-mp="12qna45pczzj4">
      <path d="M12 0C12 0 12 10.5 24 12C24 12 12 13.5 12 24C12 24 12 13.5 0 12C0 12 12 10.5 12 0Z" data-id="element-361" data-mp="1cgyh614caou8" />
    </svg>;
}